/**
 * Service: stripe
 */
angular.module('acme.common.service.stripe', [])
.service('StripeService', [ '$q', '$timeout', function($q, $timeout) {


    return {

      model: {},
      card: {
        number: '',
        cvc: '',
        exp_month: '',
        exp_year: ''
      },

      fields:  {
        number: 'cc-number',
        cvc: 'cc-cvc',
        exp_month: 'cc-month',
        exp_year: 'cc-year',
        errors: {
          number: 'Please enter a valid credit card number',
          cvc: 'Invalid CVC code',
          exp_month: 'Please enter a valid expire month',
          exp_year: 'Please enter a valid expire year'
        }
      },

      q: false,

      init: function() {
        return true;
      },

      clear: function() {
        this.card.number = '';
        this.card.cvc = '';
        this.card.exp_month = '';
        this.card.exp_year = '';
        this.model = {};
      },

      process: function() {

        var self = this;

        this.q = $q.defer();

        Stripe.setPublishableKey(CONFIG.stripe.key);
        Stripe.card.createToken({
          number: this.card.number,
          cvc: this.card.cvc,
          exp_month: this.card.exp_month,
          exp_year: this.card.exp_year
        }, function(status, response) {
          self.onResponse(status, response);
        });

        return this.q.promise;

      },

      generateToken: function() {

        var cc = this.card.number.replace(/ /g,''),
            first = cc.substr(0, 6),
            last = cc.substr(cc.length - 4, 4);

        return first + last;

      },

      processBrand: function(brand) {
        var r = brand;

        if (/American Express/.test(brand)) {
          r = 'AmericanExpress';
        }

        return r;
      },

      success: {
        response: function(response, status) {
          console.log('StripeService::success::response', this, response);

          this.model = {
            id: response.card.id,
            acmeToken: this.generateToken(),
            creditCardBrand: this.processBrand(response.card.brand),
            ccLastFourDigits: response.card.last4,
            paymentProcessorToken: response.id,
            fingerprint: response.card.fingerprint
          };

          // Respond like a normal API for consistency
          this.q.resolve({ data: { payload: this.model } });

        }
      },

      error: {
        response: function(response, status) {
          console.log('StripeService::error::response', this, response);
          var validator = {};

          switch(response.error.param) {
            case 'number':
              validator = { field: this.fields.number, len: { message: this.fields.errors.number, test: { value: '' } } };
              break;
            case 'cvc':
              validator = { field: this.fields.cvc, len: { message: this.fields.errors.cvc, test: { value: '' } } };
              break;
            case 'exp_month':
              validator = { field: this.fields.exp_month, len: { message: this.fields.errors.exp_month, test: { value: '' } } };
              break;
            case 'exp_year':
              validator = { field: this.fields.exp_year, len: { message: this.fields.errors.exp_year, test: { value: '' } } };
              break;
          }

          // Respond like a normal API for consistency
          this.q.reject({ data: { error: response.error.message, validator: validator } });
        }
      },

      onResponse: function(status, response) {
        console.log('StripeService::onResponse', status, response);

        if (status < 400) {
          this.success.response.call(this, response, status);
        } else {
          this.error.response.call(this, response, status);
        }
      }

    };

}]);